// React
import React from "react";
// React
// CSS
import styles from "./User.module.css";
// CSS
// Models
import { I_Profile } from "../../../Models/interfaces";
import { profileImg } from "../../../Images/images";
// Models
// Utils
import { errorChecker } from "../../../Utils/errorChecker";
// Utils

type UserProps = {
  data: I_Profile;
  isPending: boolean;
  isError: boolean;
};

const User: React.FunctionComponent<UserProps> = ({
  data: {
    fullName,
    phone,
    city,
    grade: { title },
    profile_pic,
  },
  isPending,
  isError,
}) => {
  return (
    <div className={`${styles.userContainer} mt-12 relative`}>
      <div className={`${styles.imgAndNameContainer} h-full`}>
        <img
          src={
            profile_pic
              ? `https://easyno.ir//users/images/${profile_pic}`
              : profileImg
          }
          alt=""
          className="w-20 h-20 rounded-full bg-white absolute -top-24"
        />
        <p className="relative -top-2">
          {errorChecker(isPending, isError, fullName)}
        </p>
      </div>
      <p className={`${styles.contentContainer} py-1 mx-4 mt-2 pb-2`}>
        <span>شماره تــلفن : </span>
        <span>{errorChecker(isPending, isError, phone)}</span>
      </p>
      <p className={`${styles.contentContainer} py-1 mx-4 mt-2 pb-2`}>
        <span> پایه تحصیلی : </span>
        <span>{errorChecker(isPending, isError, title)}</span>
      </p>
      <p className={`${styles.contentContainer} py-1 mx-4 mt-2 pb-2`}>
        <span> استان : </span>
        <span>{errorChecker(isPending, isError, city.name)}</span>
      </p>
    </div>
  );
};

export default User;
